import { AnyAri, IdentityGroupAri, IdentityUserAri } from '@atlassian/ari';
import { FormRestrictionStatus, FormSupportedPrincipalType } from '../../common/types';
import { AcceptedResponseType } from './types';

/**
 * Save the principals to the template form.
 * @return promise with the next form restriction status
 */
export const saveRestrictedPrincipalsForTemplateForm = (cloudId, projectId, templateFormLegacyId, principals) => doFetch(proformaFormRestrictionsURLPath(cloudId, projectId, templateFormLegacyId), 'POST', AcceptedResponseType.None, principals.map(principal => principal.ari.toString())).then(() => principals.length > 0 ? FormRestrictionStatus.RESTRICTED : FormRestrictionStatus.OPEN);

/**
 * Load the restricted principals associated with the template form.
 * @return promise with response (containing the principals) from Proforma.
 */
export const loadRestrictedPrincipalsForTemplateForm = (cloudId, projectId, templateFormLegacyId) => doFetch(proformaFormRestrictionsURLPath(cloudId, projectId, templateFormLegacyId), 'GET', AcceptedResponseType.Json).then(principals => ({
  principals: principals.map(toFormSupportedPrincipal)
}));
const toFormSupportedPrincipal = p => {
  const identityResourceType = AnyAri.parse(p.principalId).resourceType;
  switch (identityResourceType) {
    case 'user':
      return {
        ari: IdentityUserAri.parse(p.principalId),
        type: FormSupportedPrincipalType.USER,
        name: p.name,
        avatar: p.avatarUrl
      };
    case 'group':
      return {
        ari: IdentityGroupAri.parse(p.principalId),
        type: FormSupportedPrincipalType.USER_GROUP,
        name: p.name,
        avatar: p.avatarUrl
      };
    default:
      throw new Error(`unsupported principal type ${identityResourceType}`);
  }
};

/** Formats a url path for the form restrictions endpoint on Proforma */
const proformaFormRestrictionsURLPath = (cloudId, projectId, templateFormLegacyId) => `/gateway/api/proforma/cloudid/${cloudId}/api/frontend/jira/project/${projectId}/form/${templateFormLegacyId}/restrictions`;

/** Wrapper around fetch with a minimal API specific for form restriction requests */
const doFetch = (url, method, acceptedResponseType, body
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => fetch(url, {
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json'
  },
  method,
  ...(body && {
    body: JSON.stringify(body)
  })
}).then(response => {
  if (!response.ok) {
    throw new Error(`Unexpected response from ${response.url} ${response.status} ${response.statusText}`);
  }
  switch (acceptedResponseType) {
    case AcceptedResponseType.Json:
      return response.json();
    case AcceptedResponseType.None:
      return undefined;
    default:
      throw new Error(`Unexpected accepted response type ${acceptedResponseType}`);
  }
});